export interface LocationListEntity {
  locationId: string;
  locationName: string;
}

export namespace LocationListEntity {
  export function fromJSON(data: any[]): LocationListEntity[] {
    return data.map(
      (e): LocationListEntity => ({
        locationName: e.locationName,
        locationId: e.locationID,
      })
    );
  }
}
